
class HeaderBrandMenu {
  constructor() {
    this.brandMenu = document.getElementById('quiksilverHamburgerContent');
    this.headerBrandMenuItems = document.querySelectorAll('.header-brand-menu .header-brand-menu-child');
    this.overlay = document.getElementById('menuOverlay');
    this.MENU_ITEM_HEIGHT = 42.95;
    
    this.init();
  }

  init() {
    this.bindEvents();
  }

  bindEvents() {
    this.headerBrandMenuItems.forEach(li => {
      li.addEventListener('click', () => this.handleMenuItemClick(li));
    });

    if (this.overlay) {
      this.overlay.addEventListener('click', () => this.closeMenu());
    }
  }

  handleMenuItemClick(li) {
    if (!this.brandMenu) return;

    const menuItemText = li.textContent.trim();
    const isActive = this.brandMenu.classList.toggle('active');
    this.overlay.classList.toggle('active', isActive);

    this.adjustMenuPosition();

    if (isActive) {
      this.openSecondLevelMenu(menuItemText);
    } else {
      this.closeAllSecondLevelMenus();
    }
  }

  adjustMenuPosition() {
    const newTop = this.calculateMenuTop();
    
    this.overlay.style.top = `${newTop}px`;
    this.overlay.style.height = `calc(100vh - ${newTop}px)`;
    this.brandMenu.style.top = `${newTop}px`;
  }

  calculateMenuTop() {
    const header = document.getElementById('header-qs_rx_dc');
    const headerHeight = header ? header.offsetHeight : 60;
    
    const globalHeader = document.getElementById('globalHeaderLogo');
    const globalHeaderHeight = globalHeader ? globalHeader.offsetHeight : 0;
    
    const headerBrandMenu = document.getElementById('headerBrandMenu');
    const headerBrandMenuHeight = headerBrandMenu ? headerBrandMenu.offsetHeight : 0;
    
    const splideTrack = document.querySelector('.splide__track');
    const extraHeight = splideTrack ? splideTrack.offsetHeight : 0;
    
    return headerHeight + extraHeight + globalHeaderHeight + headerBrandMenuHeight;
  }

  openSecondLevelMenu(menuItemText) {
    setTimeout(() => {
      const targetMenuItem = this.findTargetMenuItem(menuItemText);
      
      if (targetMenuItem) {
        this.expandMenuItem(targetMenuItem);
      }
    }, 100);
  }

  findTargetMenuItem(menuItemText) {
    return Array.from(this.brandMenu.querySelectorAll('.header-qs_rx_dc-sp__top-level-toggle'))
      .find(toggle => toggle.textContent.trim() === menuItemText);
  }

  expandMenuItem(targetMenuItem) {
    const topLevelContainer = targetMenuItem.closest('.header-qs_rx_dc-sp__top-level-category-container');
    const midLevelMenu = targetMenuItem.nextElementSibling;
    
    if (midLevelMenu && midLevelMenu.classList.contains('header-qs_rx_dc-sp__mid-level-categories')) {
      const contentList = midLevelMenu.querySelectorAll('li');
      const isOpen = topLevelContainer.classList.toggle('open');
      
      midLevelMenu.style.maxHeight = isOpen ? `${contentList.length * this.MENU_ITEM_HEIGHT}px` : '0px';
      
      if (isOpen) {
        this.scrollToMenuItem(topLevelContainer);
      }
    }
  }

  scrollToMenuItem(container) {
    setTimeout(() => {
      const hamburgerContent = this.brandMenu;
      const containerOffsetTop = container.offsetTop;
      const hamburgerScrollTop = hamburgerContent.scrollTop;
      const hamburgerHeight = hamburgerContent.clientHeight;
      const containerHeight = container.offsetHeight;

      // ハンバーガーメニュー内でのスクロール位置を計算
      const targetScrollTop = containerOffsetTop - (hamburgerHeight / 2) + (containerHeight / 2);

      hamburgerContent.scrollTo({
        top: Math.max(0, targetScrollTop),
        behavior: 'smooth'
      });
    }, 150);
  }

  closeMenu() {
    this.brandMenu.classList.remove('active');
    this.overlay.classList.remove('active');
    this.closeAllSecondLevelMenus();
  }

  closeAllSecondLevelMenus() {
    const openContainers = this.brandMenu.querySelectorAll('.header-qs_rx_dc-sp__top-level-category-container.open');
    
    openContainers.forEach(container => {
      container.classList.remove('open');
      const midLevelMenu = container.querySelector('.header-qs_rx_dc-sp__mid-level-categories');
      
      if (midLevelMenu) {
        midLevelMenu.style.maxHeight = '0px';
      }
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new HeaderBrandMenu();
});